import Home from './home'
import CollectionRecord from './collectionRecord'
export default {
  Home,
  CollectionRecord
}
